import config from "appConfig";
import { Lesson } from "@jelly/lesson";
import task01 from "./layouts/task-01/task";
import theory from "./theory";
const lesson: Lesson = {
  id: "72c6e59e-471b-4087-b400-afeb12528494",
  publicId: "24",
  name: "Ambisonics",
  difficulty: 3,
  contentTypes: { audio: true, interactive: true, video: true },

  body: [
    {
      theory: theory,
      title: "Ambisonics",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_REACT_URL}/0324/`,
                },
              },
            },
          },
        },
      },
    },
    task01,
  ],
};

export default lesson;
